export default __webpack_public_path__ + "static/media/almostThere.4b6e441f.webp";